module.exports = __webpack_public_path__ + "img/18.89fe917a.png";